module.exports = __webpack_public_path__ + "img/culture_bn.44c7a090.png";